import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from './app/query-client';
import { App as AntApp, ConfigProvider } from 'antd';
import { RouterProvider } from 'react-router-dom';
import { theme } from './app/theme';
import { router } from './app/router';
import { AuthProvider } from './auth/AuthProvider';
import '@fontsource-variable/inter';
import './app/global.css';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';

dayjs.extend(relativeTime);

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ConfigProvider theme={theme} tag={{ variant: 'filled' }} card={{ variant: 'outlined' }}>
      <AntApp>
        <QueryClientProvider client={queryClient}>
          <AuthProvider>
            <RouterProvider router={router} />
          </AuthProvider>
        </QueryClientProvider>
      </AntApp>
    </ConfigProvider>
  </React.StrictMode>,
);
